import { NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { type RouteRecordRaw } from 'vue-router';
import { TOURIST_ROUTE_NAMES } from './tourist-route-names';
import { isUserLogin } from '@eureka/utils/account';
import { injectService } from '@patsnap/tahiti-core';
import { AgentAuthService } from '@/domains/agent/services/agent-auth-service';
import { isCNRegion } from '@eureka/utils/environment';

export const touristRouterList: RouteRecordRaw[] = [
    {
        path: '/tourist',
        name: TOURIST_ROUTE_NAMES.TOURIST,
        redirect: '/home',
        component: () => import('@/pages/Layout.vue'),
        beforeEnter: (_to, _from, next) => {
            if (isCNRegion()) {
                next({ path: '/home' });
            } else {
                next();
            }
        },
        children: [
            {
                path: 'ai-ls',
                name: TOURIST_ROUTE_NAMES.TOURIST_AI_LS,
                component: () => import('@/pages/tourist/Tourist.vue'),
                redirect: '/home',
                children: [
                    {
                        path: ':lsAgentName/:lsAgentId',
                        meta: {
                            navModuleType: NAV_MENU_TYPE.LS_CHAT,
                        },
                        name: TOURIST_ROUTE_NAMES.TOURIST_AI_LS_AGENT_DETAIL,
                        component: () => import('@/pages/ai-ls/AiLs.vue'),
                        beforeEnter: async(to, from, next) => {
                            if (to.params.lsAgentName === 'document-agent') {
                                const id = to.params.lsAgentId as string;
                                const agentAuthService = injectService<AgentAuthService>(AgentAuthService);
                                const hasPermission = await agentAuthService.checkDocumentAnalyzerPermission(id);
                                if (hasPermission) {
                                    next();
                                } else {
                                    next({ name: 'home', query: { agent: 'pda' } });
                                }
                            } else {
                                next()
                            }
                        },
                    }
                ],
            },
            {
                path: 'ai',
                name: TOURIST_ROUTE_NAMES.TOURIST_AI,
                component: () => import('@/pages/tourist/Tourist.vue'),
                redirect: '/home',
                meta: {
                    navModuleType: NAV_MENU_TYPE.AI_GENERATE,
                },
                children: [
                    {
                        path: 'agent-flow/:agent_job_id',
                        name: TOURIST_ROUTE_NAMES.TOURIST_AI_AGENT_FLOW,
                        component: () => import('@/pages/ai/AgentFlow.vue'),
                        beforeEnter: async(_to, _from, next) => {
                            const isGuest = !await isUserLogin();
                            if (isGuest) {
                                next()
                                return
                            }
                            next({ path: '/home' });
                        },
                    }
                ],
            }
        ],
    }
]
